export function Cases() {
  return (
    <section className="section" id="cases">
      <div className="container">
        <div className="sectionHead" data-reveal>
          <h2 className="h2">Наши кейсы</h2>
          <p className="muted">
                Отстояли права и уже получили компенсанию на сумму 3,7 млн рублей.
          </p>
        </div>

        <div className="caseStories">
          {[
            {
              title: "Дело № А40-102811/25-110-778",
              metric: "50 000 ₽",
              text: "Автор Алексей И. случайно обнаружил, что его фотография «Огонь в барбекю и два пустых шезлонга на заднем дворе» была размещена на нескольких маркетплейсах (Яндекс.Маркет, Мегамаркет и др.) без его согласия.",
              image: "https://buyrights.ru/wp-content/uploads/2026/02/0fd7f648-9319-403d-b842-6fe11b9b1fce-optimized.jpg",
              link: "https://buyrights.ru/all-cases/kejs-iz-praktiki-kompaniya-skopirovala-foto-v-internete-i-vyplatila-50-000-rublej-kompensaczii/"
            },
            {
              title: "Дело № А56-14361/2025",
              metric: "45 000 ₽",
              text: "К нам обратился фотограф, который делал серию уникальных снимков «Angry businesswoman working with laptop in office». Автор разместил их на фотобанке и продавал. Но со временем заметил, что его работы слишком часто использовались на маркетплейсах. При этом покупали их гораздо реже.",
              image: "https://buyrights.ru/wp-content/uploads/2026/02/1-kejs-sdatoe-foto-optimized.png",
              link: "https://buyrights.ru/all-cases/1040/"
            },
            {
              title: "Досудебное урегулирование",
              metric: "45 000 ₽",
              text: "Марина — профессиональный фотограф. Однажды она заметила свою фотографию на сайте санатория, размещённую на главной странице для привлечения клиентов.",
              image: "https://buyrights.ru/wp-content/uploads/2025/08/case-6-optimized.jpg",
              link: "https://buyrights.ru/all-cases/vsego-odno-foto-za-25-000-rublej/"
            }
          ].map((c) => (
            <article key={c.title} className="card caseStory" data-reveal>
              <div className="caseStoryImage">
                <img src={c.image} alt="" loading="lazy" />
              </div>
              <div className="caseStoryBody">
                <div className="caseTop">
                  <h3 className="h3">{c.title}</h3>
                  <span className="metric">{c.metric}</span>
                </div>
                <p className="muted">{c.text}</p>
                <a
                  className="caseStoryLink"
                  href={c.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Читать далее…
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

